import { createStore } from "redux";
import languageDataReducer from "./reducers/reducers";

export default createStore(languageDataReducer);

export interface StoreProps {
  language: number;
  setLanguage: (language: number) => void;
}
